import classnames from 'classnames';
import styles from './../ExpectationsContent.scss';

export const ExpectationCard = ({ label, children, checked=false, indent = false }) => (
    <div className={classnames(styles.expectationCard,
        {
            [styles.indent]: indent,
            [styles.checked]: checked,
        },
        
    )} data-cy="ExpectationCard">
        <label data-cy="ExpectationCard-children">
            {children}
            <span data-cy="ExpectationCard-label">{label}</span>
        </label>
    </div>
);
